module.exports = __webpack_public_path__ + "media/app/assets/mailers/bnet-977d4f64f382ce0772bb584dc6c152ba.png";